module.exports = __webpack_public_path__ + "img/Checkbox-active.83307ca1b.svg";